import { Flex, HStack, Tag, TagLabel } from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomFieldValue } from '../../../types';

type ProviderLink = { providerId: string; providerLabel: string };

type SupervisingPhysicianBadgeProps = {
  customField?: CustomFieldValue[];
};

const SupervisingPhysicianBadge: React.FC<
  SupervisingPhysicianBadgeProps
> = ({ customField }) => {
  const navigate = useNavigate();

  // First: Early exit if empty
  if (!Array.isArray(customField) || customField.length === 0) {
    return null;
  }

  const field = customField[0];
  const providers: ProviderLink[] = Array.isArray(
    field.metadata?.providers
  )
    ? (field.metadata!.providers as ProviderLink[])
    : [];

  // Backward compatibility: check metadata first, then fallback to value
  const hasProviders =
    Array.isArray(providers) && providers.length > 0;

  return (
    <Flex
      direction="column"
      align="start"
      gap="0.25rem"
      height={'auto'}
    >
      {/* Provider chips (clickable) */}
      {hasProviders && (
        <HStack spacing={1} flexWrap="wrap">
          {providers.map((p: ProviderLink) => (
            <Tag
              as="button"
              key={p.providerId}
              size="sm"
              colorScheme="blue"
              borderRadius="full"
              variant="outline"
              cursor="pointer"
              onClick={() => navigate(`/providers/${p.providerId}`)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  navigate(`/providers/${p.providerId}`);
                }
              }}
              _hover={{
                bg: 'blue.100',
                borderColor: 'blue.400',
                transform: 'translateY(-1px)',
              }}
              _active={{ transform: 'translateY(0)' }}
              transition="all 0.15s ease-in-out"
              fontSize="0.75rem"
              fontWeight="500"
              tabIndex={0}
            >
              <TagLabel>{p.providerLabel}</TagLabel>
            </Tag>
          ))}
        </HStack>
      )}
    </Flex>
  );
};

export default SupervisingPhysicianBadge;
